import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import Pagination from 'react-js-pagination';

import ViewItemsPerPage from "../ViewItemsPerPage";

interface ListUsersProps {
  usersList: any[];
  usersListCount: number;
  usersListPageIndex: number;
  usersListPageSize: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
  findOptions: any;
  handleFindUser: (findOptions: any) => void;
  resetFindOptions: () => void;
  toggleActivation: (userId: number, userDetails: any) => void;
}

const ListUsers: React.FC<ListUsersProps> = ({
  usersList,
  usersListCount,
  usersListPageIndex,
  usersListPageSize,
  onChangePageIndex,
  onChangePageSize,
  findOptions,
  handleFindUser,
  resetFindOptions,
  toggleActivation,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState(findOptions);

  const handleModalClose = () => setShowModal(false);
  const handleModalOpen = () => setShowModal(true);

  const onChangeFieldValue = (value: object) => {
    setSearchOptions({ ...searchOptions, ...value });
  }
  const onClickFind = (findOptions: any) => {
    handleFindUser(findOptions);
    handleModalClose();
  };

  useEffect(() => { setSearchOptions(findOptions) }, [findOptions])

  return (
    <div>
      <Button variant="secondary" className="ml-1 mb-3" onClick={handleModalOpen}>
        Find Options
      </Button>
      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Find User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            className="mb-3"
            variant="secondary"
            onClick={() => resetFindOptions()}>
            Clear Parameters
          </Button>
          <Form>
            <Form.Group className="mb-3" controlId="find-customer-id">
              <Form.Label>Customer ID</Form.Label>
              <Form.Control
                type="text"
                value={searchOptions.userId ? searchOptions.userId : ''}
                onChange={(e) => onChangeFieldValue({ userId: parseInt(e.target.value) })}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="find-full-name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={searchOptions.name ? searchOptions.name : ''}
                onChange={(e) => onChangeFieldValue({ name: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="find-email">
              <Form.Label>email</Form.Label>
              <Form.Control
                type="email"
                value={searchOptions.email ? searchOptions.email : ''}
                onChange={(e) => onChangeFieldValue({ email: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="find-mobile">
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                type="text"
                value={searchOptions.mobile ? searchOptions.mobile : ''}
                onChange={(e) => onChangeFieldValue({ mobile: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>Close</Button>
          <Button variant="primary" onClick={() => onClickFind(searchOptions)}>Find</Button>
        </Modal.Footer>
      </Modal>
      <Table striped hover size="sm">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>
              <div>Email</div>
              <div>Mobile</div>
            </th>
            <th>
              <div>Gender</div>
              <div>DOB</div>
            </th>
            <th>
              <div>City</div>
              <div>State</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {usersList.map((user) => (
            <tr key={user.userId}>
              <td>{user.userId}</td>
              <td>{[user.firstName, user.middleName, user.lastName].filter(Boolean).join(" ")}</td>
              <td>
                <div>{user.email}</div>
                <div>{user.mobile}</div>
              </td>
              <td>
                <div>{user.gender}</div>
                <div>{user.dob}</div>
              </td>
              <td>
                <div>{user.city}</div>
                <div>{user.state}</div>
              </td>
              <td>
                <Button
                  variant={user.isActive ? "danger" : "success"}
                  style={{ width: '100px' }}
                  onClick={() => toggleActivation(user.userId, { ...user, isActive: !user.isActive })}
                >
                  {user.isActive ? "Deactivate" : "Activate"}
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        activePage={usersListPageIndex + 1}
        totalItemsCount={usersListCount}
        itemsCountPerPage={usersListPageSize}
        onChange={onChangePageIndex}
        itemClass="page-item"
        linkClass='page-link'
        firstPageText="First"
        lastPageText="Last"
      />
      <ViewItemsPerPage
        selectedPageSize={usersListPageSize}
        onSelectPageSize={onChangePageSize}
      />
    </div>
  );
};

export default ListUsers;
